import { IsiModeConfirm, IsiButtonType } from "../Isilog.enums";
import { IsiEntity } from "./IsiEntity";
import { IIsiUIFlowResult } from "../Isilog/Core/IIsiUIFlowResult";
import { IsiPlBusiness, ParamPlBusiness } from "../Isilog/PresentationLogic/IsiPlBusiness"
import { IIsiServerToClientBusinessObject } from "../IsiTypeScript/Isilog.IsiFramework.IsiCommonLibrary";
import { IIsiUIFlowResultGeneric } from "../Isilog/Core/IIsiUIFlowResultGeneric";

export class IsiBc {

    pEntity;
    sMessage;
    iTypeIcon;
    bCheckOk;

    constructor(entity, message, typeIcon, checkOk) {
        ///////////////////////////////////////////////////////////////////////////////////
        // Attributs
        ///////////////////////////////////////////////////////////////////////////////////       
        // Entite courante
        this.pEntity = entity;
        // Message de bilan
        this.sMessage = message;
        // type d icone du message
        this.iTypeIcon = typeIcon;
        // Retour vrai ou faux du check
        this.bCheckOk = checkOk;
    }
}

class IsiClientToServerBusinessObject {

    Responses = []

    addResponse(key, response) {
        this.Responses[this.Responses.length] = new IsiBusinessMessageClientResponse(key, response);
    }

}

class IsiBusinessMessageClientResponse {

    Key;
    Response;

    constructor(key, response) {
        this.Key = key;
        this.Response = response;
    }
}

export function ensureClientToServerBusinessObject(clientToServerBusinessObject) {
    if (typeof (clientToServerBusinessObject) === 'undefined' || clientToServerBusinessObject === false) {
        clientToServerBusinessObject = new IsiClientToServerBusinessObject();
    }
    return clientToServerBusinessObject;
}

export function flushClientToServerBusinessObject(clientToServerBusinessObject) {
    if (typeof (clientToServerBusinessObject) !== 'undefined' && clientToServerBusinessObject !== false) {
        jQuery('#ihdBC').val(Sys.Serialization.JavaScriptSerializer.serialize(clientToServerBusinessObject));
    }
}
function showUndefinedConfirmationMode(message: any, objRtnJs, clientToServerBusinessObject): Promise<IIsiUIFlowResult> {
    return new Promise((resolve, reject) => {
        const messageLabel = message.message;

        //GBAU - 15/09/2014 - Ancien fonctionnement : Message d'erreur uniquement
        // Affichage du message
        let option = {
            iconType: message.Type,
            popin: false,
            callback: {
                if: function () { return uiCore.getSubmit(); },
                func: function (objRtnJs, clientToServerBusinessObject) {
                    return function () {
                        iws_BusinessCheckTreatMessages(objRtnJs, clientToServerBusinessObject).then((result) => {
                            resolve(result);
                        });
                    }
                }(objRtnJs, clientToServerBusinessObject)
            },
            height: null,
            width: null
        }
        if (messageLabel > 1) {
            option.height = message.PopupHeight;
            option.width = message.PopupWidth;
            uiCore.showMessage(messageLabel, option);
        } else {
            //YLAR pour afficher un feedback d'erreur, il faut utiliser showErrorMessage
            uiCore.showErrorMessage(messageLabel, option);
        }
        //GBAU - POPIN : Passage en bloquant pour affichage en popin plutôt que feedback car multi-ligne
        // YLAR : Utilisation de feedback pour afficher les erreurs
        resolve({ result: true, continue: uiCore.getSubmit() });
    });
}
function showValidateOrOkMessage(message, objRtnJs, clientToServerBusinessObject): Promise<IIsiUIFlowResult> {
    const messageLabel = message.message;

    return new Promise((resolve, reject) => {
        //GBAU - 15/09/2014 - Nouveau fonctionnement : Si c'est une erreur, on s'arrête
        //ARAN - 20/04/2018 - Vu que si c'est une erreur on arrête, alors on submit quand ce n'en est pas une !
        // Affichage du message
        let option = {
            iconType: message.Type,
            popin: objRtnJs.nbMessage > 1,
            callback: {
                if: function () { return uiCore.getSubmit(); },
                func: function (objRtnJs, clientToServerBusinessObject) {
                    return function () {
                        iws_BusinessCheckTreatMessages(objRtnJs, clientToServerBusinessObject).then((result) => {
                            resolve(result)
                        });
                    }
                }(objRtnJs, clientToServerBusinessObject)
            },
            height: null,
            width: null
        }
        // YLAR 21/06/2016 DEV123264 : Affichage d'un feedback dans le cas ou un seul message d'erreur est affiché.
        if (objRtnJs.nbMessage > 1) {
            option.height = message.PopupHeight;
            option.width = message.PopupWidth;
        }
        //ARAN - 20/04/2018 - On affiche une erreur seulement dans le cas ou c'est une erreur
        if (message.isError) {
            //GBAU - POPIN : Passage en bloquant pour affichage en popin plutôt que feedback car multi-ligne
            uiCore.showErrorMessage(messageLabel, option);
        } else {
            uiCore.showMessage(messageLabel, option);
        }
        resolve({ result: true, continue: !message.isError });
    });
}
/**
 * Evalue le type de retour et les actions à faire suit à l'affichage d'un message du métier.
 * @param userResponse
 * @param message
 * @returns
 */
function getResponse(userResponse: any, message: any): IIsiUIFlowResultGeneric<any> {
    const result: IIsiUIFlowResultGeneric<any> = {
        result: true,
        continue: true,
        reponse: null
    };

    if (userResponse === IsiButtonType.No && (message.confirmationMode === IsiModeConfirm.ValidateCancel || message.confirmationMode === IsiModeConfirm.OkCancel)) {
        //Cas particuler... Dans ces modes là, le Cancel renvoi No et non Cancel
        userResponse = IsiButtonType.Cancel;
    }

    switch (userResponse) {
        case IsiButtonType.Yes:
            result.reponse = true;
            break;
        case IsiButtonType.Apply:
            result.reponse = true;
            break;
        case IsiButtonType.No:
            result.reponse = false;
            break;
        case IsiButtonType.Cancel:
            result.reponse = null;
            result.continue = false;
            break;
    }
    return result;
}
function showOtherMessage(message, objRtnJs, clientToServerBusinessObject): Promise<IIsiUIFlowResult> {
    return new Promise((resolve, reject) => {
        uiCore.showConfirm({
            message: message.message,
            confirmMode: message.confirmationMode,
            height: message.PopupHeight,
            width: message.PopupWidth,
            callback: {
                func: (userResponse) => {
                    const bRet = getResponse(userResponse, message);

                    if (bRet.continue) {
                        clientToServerBusinessObject.addResponse(message.key, bRet.reponse);
                        iws_BusinessCheckTreatMessages(objRtnJs, clientToServerBusinessObject).then((result) => {
                            if (uiCore.currentScreen.buisnessTreatmentDlg !== null) {
                                uiCore.currentScreen.buisnessTreatmentDlg(message.key).then((resultBTOverridable) => {
                                    resolve(resultBTOverridable);
                                });
                            } else {
                                resolve(result);
                            }
                        });
                    } else {
                        clientToServerBusinessObject = null;
                        uiCore.setSubmit(false);
                        resolve({ result: true, continue: false });
                    }

                }
            }
        });
    });
}
export function iws_BusinessCheckTreatMessages(objRtnJs, clientToServerBusinessObject): Promise<IIsiUIFlowResult> {
    return new Promise<IIsiUIFlowResult>((resolve, reject) => {
        if (objRtnJs.messages && objRtnJs.messages.length > 0) {
            // On stoque le nombre de message car on fait un pop sur le tableau donc on perd le nombre total
            if (typeof (objRtnJs.nbMessage) === 'undefined') {
                objRtnJs.nbMessage = objRtnJs.messages.length;
            }

            // CLEM - Dysf74341, on ne dépilait pas dans le bon sens les messages
            const message = objRtnJs.messages.shift();
            const messageLabel = message.message;

            if (messageLabel !== "") {

                //uiCore.log("iws_BusinessCheckTreatMessages : message.IsiMessage" + message.IsiMessage);// TRACE_GRID_UPDATE_AJAX
                _traiteMessage(message, objRtnJs, clientToServerBusinessObject).then((resultTraiteMessage) => {
                    resolve(resultTraiteMessage);
                });

            } else {
                resolve({ result: true, continue: true });
            }
        } else {
            // On stoque le nombre de message car on fait un pop sur le tableau donc on perd le nombre total
            if (typeof (objRtnJs.nbMessage) === 'undefined') {
                objRtnJs.nbMessage = 0;
            }

            resolve({ result: true, continue: true });
        }
    });
}
window.iws_BusinessCheckTreatMessages = iws_BusinessCheckTreatMessages;
/*
 * Gestion des messages
 */
function _traiteMessage(message: any, objRtnJs, clientToServerBusinessObject): Promise<IIsiUIFlowResult> {
    return new Promise<IIsiUIFlowResult>((resolve, _reject) => {
        if (typeof (message.confirmationMode) === 'undefined' || message.confirmationMode === IsiModeConfirm.Undefined) {
            showUndefinedConfirmationMode(message, objRtnJs, clientToServerBusinessObject).then((result) => {
                resolve(result);
            });
        } else {

            if (message.confirmationMode === IsiModeConfirm.ValidateOnly || message.confirmationMode === IsiModeConfirm.OkOnly) {
                showValidateOrOkMessage(message, objRtnJs, clientToServerBusinessObject).then((result) => {
                    resolve(result);
                });
            } else {
                showOtherMessage(message, objRtnJs, clientToServerBusinessObject).then((result) => {
                    resolve(result);
                });
            }
        }
    });
}

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : CEGO
'- Date        : 19/05/2009
'- Description : Traitement Ajax pour appeler une regle particuliere du composant metier.
'-----------------------------------------------------------------------------------------*/
export function iws_BusinessRule(nameRule): Promise<IsiBc> {
    return new Promise<IsiBc>((resolve, reject) => {
        // Recuperation de toutes les valeurs des controles du formulaire.
        const sInfosEntityJson = iwsAllCtrls.getSerializeJsonInfosEntity();
        const verif: IsiPlBusiness = new IsiPlBusiness();
        uiCore.addBusinessRuleRunning(nameRule);

        const opts: ParamPlBusiness = {
            codeTreatment: nameRule,
            codeAction: '',
            checkToDo: false,
            infosEntity: sInfosEntityJson
        }
        verif.CheckBusiness(opts).then((verifResult) => {
            const objRtnJs: IIsiServerToClientBusinessObject = verifResult.businessResult as IIsiServerToClientBusinessObject;
            // Construction de l entite
            //GBAU - 08/10/2018 - Modification suite intégration #8732
            const pEntity = new IsiEntity(objRtnJs.fields, objRtnJs.otherFields);
            //GBAU - 03/10/2014 : Correction de l'affichage des messages suite au notification dans les règles de gestion
            let message;
            if (objRtnJs.messages && objRtnJs.messages.length > 0) {
                message = objRtnJs.messages[0];
            } else {
                message = {};
                message.message = "";
            }

            uiCore.removeBusinessRuleRunning(nameRule);
            // Stockage d'une message de retour de la regle metier ainsi que l entite
            resolve(new IsiBc(pEntity, message.message, 0, true));
        }).catch(() => {
            uiCore.removeBusinessRuleRunning(nameRule);
        });
    });
}
window.iws_BusinessRule = iws_BusinessRule;
